'use strict';
import register from './core';
import '../functions/jquery-global.js';
import flatpickr from "flatpickr";
import { Sweden } from 'flatpickr/dist/l10n/sv.js';
import { dateValidation } from '../components/date-picker';


register('projectform-validator', function (element) {
  var $projectform = $('#project-form');
  var $element = $(element);
  var eventStartDate = $element.find("#project-start-date");
  var eventEndDate = $element.find("#project-end-date");
  let dateTimeValid = false;

  var datePickerConfig = {
    dateFormat: "Y-m-d",
    locale: "sv",
    allowInput: true,
    onChange: function (selectedDates, dateStr, instance) {
      validate();
    }
  };
  flatpickr.localize(Sweden);
  flatpickr(eventStartDate, datePickerConfig);
  flatpickr(eventEndDate, datePickerConfig);


  var validate = function () {
    $("#error").hide();
    var eventStart = eventStartDate.val();
    var eventEnd = eventEndDate.val();

    dateTimeValid = dateValidation(eventStart, eventEnd)
    if (!dateTimeValid) {
      $("#error").show();
    }
    handleSubmitBtn();
  };

  $projectform.on('submit', function (event) {
    $("#contactperson-error").hide();
    var contactValid = CheckPersonSearch("#selected-contactperson");
    if (!contactValid) {
      event.preventDefault();
      $("#contactperson-error").show();
      ScrollTo("#contactperson-input-label", 200);
      return;
    }

    $("#responsible-error").hide();
    var contactValid = CheckPersonSearch("#selected-responsible");
    if (!contactValid) {
      event.preventDefault();
      $("#responsible-error").show();
      ScrollTo("#responsible-input-label", 200);
      return;
    }

    $("#faculty-error").hide();
    var facultyValid = CheckFaculty();
    if (!facultyValid) {
      event.preventDefault();
      $("#faculty-error").show();
      ScrollTo("#faculty-list", 200);
      return;
    }
  });

  function CheckPersonSearch(element) {
    var check = false;

    if ($(element + ' li').length > 0) {
      check = true;
    } 
    return check;
  }

  function CheckFaculty() {   
    var check = false;

    var facultyOptions = $('input[name=Faculties]:checked');
    if (facultyOptions.length > 0) {
      check = true;
    }
    return check;
  }

  function ScrollTo(element, time) {
    var timelength = timelength || 1000;
    $('html, body').animate({
      scrollTop: $(element).offset().top - 100
    }, timelength, function () {
    });
  }

  function handleSubmitBtn() {
    let formValid = dateTimeValid;
    $(":submit", $element).prop("disabled", !formValid);
  }
  
});
